import { useEffect } from 'react';
import { useCRMAddRegister } from './hooks/useCRMAddRegister';
import { Box, IconButton, MenuItem, TextField, Tab, Tabs, SwipeableDrawer, InputAdornment } from '@mui/material';
import { Search, Close, CreateNewFolder, AddBusiness, Clear } from '@mui/icons-material';
import { FlexGrid, Typography, useThemeProvider, Button, Skeleton } from '@albo-ui/core';

import DataTable from 'react-data-table-component';
import { customStyles2 } from '../../../util/TableStyles';
import { noDataComponent } from '../../../util/DataObject';
import { paginationComponentOptions } from '../../../util/i18n-es';
import Checkbox from "@mui/material/Checkbox";

export const CRMCreateRegister = ({ changeAlert, changeLoader, sectionData, platformData, platformInfo, formSelected, selectedSection, open, onClose, catalogs, getLeadByUuid, crmType }: any) => {    
    const { data, columns, loading: loadingTable, form, tabActive, tabs, zPos, page, perPage, totalRows, isValidFilter, isValid, newRegister, error, handlePageChange, handlePerRowsChange, storeData, onHandleChange, onHandleSearch, crmFilter, changeTab, cleanForm, onCreate, onUpdate, selected, clearInput } = useCRMAddRegister(changeAlert, onClose, getLeadByUuid)
    const { theme } = useThemeProvider();

    useEffect(() => {
        open ? storeData(selectedSection, sectionData, crmType, platformData, platformInfo) : cleanForm();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);
    useEffect(() => {
        changeLoader(loadingTable)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable]);

    const toggleDrawer = (anchor: 'right', open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
        if (event && event.type === 'keydown' && ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')) {
            return;
        }
    };

    const showFields = (prop1, prop2, label, aux_label = null, required, select= null) => {
        if(select){
            return <TextField key={`${prop1}-${prop2}`} select onChange={onHandleChange.bind(this, prop1, prop2, null)} defaultValue={-1} label={`${label} ${aux_label ? aux_label : ""}`} size='small' color='secondary' variant='standard' sx={{mb: 2}} fullWidth InputLabelProps={{ shrink: true }} required={required}>
                <MenuItem value={-1} disabled>Seleccione</MenuItem>
                {platformData && platformData[select].map((item) => (
                    <MenuItem key={`${prop1}-${prop2}-${item.key}`} value={item.key}>{item.label}</MenuItem>
                    ))}
            </TextField>
        } else if(prop2.includes('phone')){
            return <Box display={'flex'} key={`phone-${prop1}-${prop2}`}><TextField select onChange={onHandleChange.bind(this, prop1, prop2, 'phone_code')} defaultValue={'52'} label={'Código'} size='small' color='secondary' variant='standard' sx={{mb: 2, mr: 1, width: '55%'}} InputLabelProps={{ shrink: true }} SelectProps={{style: {fontSize: 14}}} required={required}>
                <MenuItem value={-1} disabled>Seleccione</MenuItem>
                { catalogs.map((item, index) => {
                    return (
                        <MenuItem key={`dial-${index}`} value={item.m[0].dial}>
                            (+{item.m[0].dial}) {item.m[0].code2}
                        </MenuItem>
                    );
                })}
                </TextField>
                <TextField onChange={onHandleChange.bind(this, prop1, prop2, 'phone')} label={`${label} ${aux_label ? aux_label : ""}`} size='small' color='secondary' variant='standard' sx={{mb: 2}} fullWidth InputLabelProps={{ shrink: true }} required={required}/>
            </Box>
        } else {
            return <TextField key={`${prop1}-${prop2}`} required={required}
            value={
                prop2 && newRegister[prop1] ? 
                newRegister[prop1][prop2] :
                prop1 ? newRegister[prop1] : 
                newRegister[prop2] || ''
            } onChange={onHandleChange.bind(this, prop1, prop2, null)} label={`${label} ${aux_label ? aux_label : ""}`} size='small' color='secondary' variant='standard' sx={{mb: 2}} fullWidth InputLabelProps={{ shrink: true }}/>
        }
    };

    const validateType = () => {
        switch (selectedSection+"|"+tabActive) {
            case "company|create":
                return <>
                    <CreateNewFolder sx={{ marginRight: 2 }}/>
                    <Typography variant='h2' style={{fontSize: '1.2rem'}} color={'white'}>Crear contacto</Typography>
                </>
            case "company|update":
                return <>
                    <AddBusiness sx={{ marginRight: 2 }}/>
                    <Typography variant='h2' style={{fontSize: '1.2rem'}} color={'white'}>Agregar contacto existente</Typography>
                </>
            case "contact|create":
                return <>
                    <CreateNewFolder sx={{ marginRight: 2 }}/>
                    <Typography variant='h2' style={{fontSize: '1.2rem'}} color={'white'}>Crear empresa</Typography>
                </>
            case "contact|update":
                return <>
                    <AddBusiness sx={{ marginRight: 2 }}/>
                    <Typography variant='h2' style={{fontSize: '1.2rem'}} color={'white'}>Agregar empresa existente</Typography>
                </>
        }
    }
    
    return (
        <SwipeableDrawer anchor={'right'} open={open} onClose={onClose} onOpen={toggleDrawer('right', true)} sx={{width: 'inherit', zIndex: zPos, filter: zPos !== 45 ? 'blur(4px)': "none" }}>
            <Box width={600} display={'flex'} zIndex={1} position={'sticky'} top={0} px={5} py={3} sx={{backgroundColor: theme.colors.indigo}} color={theme.colors.white} justifyContent={'space-between'} alignItems={'center'}>
                <Box display={'flex'} alignItems={'center'}>
                    {validateType()}
                </Box>
                <Close sx={{cursor: 'pointer'}} onClick={onClose}/>
            </Box>
            <Box width={600} px={5} py={3} >
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }} mb={2} >
                    <Tabs sx={{width: '100%', paddingBottom: 4}} variant='fullWidth' value={tabActive} indicatorColor='secondary' textColor='secondary' >
                        {tabs.map((item, index) => {
                            return <Tab key={index} label={item.title} value={item.name} onClick={changeTab.bind(this, item.name)} 
                            sx={{textTransform: 'none', fontWeight: 700, fontFamily: 'Muli,sans-serif', fontSize: 14, backgroundColor: tabActive === item.name ? theme.colors.lightGray : theme.colors.iconLightGrayBackground}} />
                        })}
                    </Tabs>
                </Box>

                <FlexGrid container fullWidth fullHeight style={{display: "block", marginBottom: 40}}>
                    <FlexGrid item fullWidth>
                        {tabActive === "create" ? formSelected?.map((obj) => {
                            if(!obj["text"]){
                                return obj['prop'] ? 
                                showFields(obj['prop'], obj['key'], obj['label'], obj["aux_label"], obj["required"])
                                :
                                showFields(obj['section'], obj['key'], obj['label'], obj["aux_label"], obj["required"], obj['catalog'])
                            }
                            return null;
                        })  : 
                            <>
                                <FlexGrid container>
                                    <TextField select value={form["filters"]['type'] || -1} onChange={onHandleSearch.bind(this, "type", null)} defaultValue={-1} size='small' sx={{width: '17rem'}} color='secondary'>
                                        <MenuItem value={-1} disabled>Tipo de dato</MenuItem>
                                        <MenuItem value={'email'}>Email</MenuItem>
                                        {selectedSection !== "company" ?
                                            <MenuItem value={'company_name'}>Nombre de empresa</MenuItem>
                                            : 
                                            <MenuItem value={'name'}>Nombre</MenuItem>
                                        }
                                    </TextField>
                                    {form["filters"]['type'] === 'name' ?
                                        <>
                                        <TextField
                                            label={'Nombres'} value={(form["filters"]['keyword'] && form["filters"]['keyword']['gname']) || ''} color='secondary' size='small' fullWidth 
                                            InputProps={{style: {height: 40}}} 
                                            onChange={onHandleSearch.bind(this, 'keyword', 'gname')}
                                        />
                                        <TextField
                                            label={'Apellidos'} value={(form["filters"]['keyword'] && form["filters"]['keyword']['lname']) || ''} color='secondary' size='small' fullWidth 
                                            InputProps={{
                                                style: {height: 40},
                                                endAdornment: (
                                                    form["filters"]['keyword'] && <InputAdornment position="end">
                                                        <IconButton onClick={clearInput.bind(this)} edge="end">                
                                                            <Clear />
                                                        </IconButton> 
                                                    </InputAdornment>
                                                ),
                                            }} 
                                            onChange={onHandleSearch.bind(this, 'keyword', 'lname')}
                                        />
                                        </>
                                        :
                                        <TextField
                                            label={'Explorar registros...'} value={form["filters"]['keyword'] || ''} color='secondary' size='small' fullWidth 
                                            InputProps={{
                                                style: {height: 40},
                                                endAdornment: (
                                                    form["filters"]['keyword'] && <InputAdornment position="end">
                                                        <IconButton onClick={clearInput.bind(this)} edge="end">                
                                                            <Clear />
                                                        </IconButton> 
                                                    </InputAdornment>
                                                ),
                                            }} 
                                            onChange={onHandleSearch.bind(this, 'keyword', null)}
                                        />
                                    }
                                    <IconButton disabled={isValidFilter} onClick={crmFilter.bind(this)} sx={{padding: '0 !important'}}><Search sx={{p: 1, ml: 2, borderRadius: 2, boxSizing: 'content-box', color: 'white', backgroundColor: !isValidFilter ? "#8bc179" : "#EDF0F4" }}/></IconButton>
                                </FlexGrid>

                                <FlexGrid container style={{margin: '25px 0' }} direction='column'>
                                {
                                    loadingTable ?
                                        <Skeleton width='100%' height='100px' />
                                        :
                                        <DataTable
                                            columns={columns}
                                            data={data}
                                            customStyles={customStyles2}
                                            noDataComponent={noDataComponent}
                                            progressPending={loadingTable}
                                            pagination
                                            paginationServer
                                            paginationDefaultPage={page}
                                            paginationPerPage={perPage}
                                            paginationTotalRows={totalRows}
                                            onChangeRowsPerPage={handlePerRowsChange}
                                            onChangePage={handlePageChange}
                                            paginationComponentOptions={paginationComponentOptions}
                                            expandOnRowClicked={false}
                                            selectableRows
                                            selectableRowsNoSelectAll={true}
                                            selectableRowsComponent={Checkbox}
                                            onSelectedRowsChange={selected}
                                        />
                                }
                                </FlexGrid>
                            </>
                        }
                        {tabActive === "create" && 
                            <>
                                <TextField select value={newRegister['origin_platform'] || '-1'} onChange={onHandleChange.bind(this, "origin_platform", "", null )} label={"Origen (Obligatorio)"} size='small' color='secondary' variant='standard' sx={{mb: 2}} fullWidth InputLabelProps={{ shrink: true }} required>
                                    <MenuItem value={"-1"} disabled>Seleccione</MenuItem>
                                    {platformData && platformData['origin_platform']?.map((item, index) => {
                                        return <MenuItem key={`option-${index}`} value={item.key}>{item.label}</MenuItem>
                                    })}
                                </TextField>
                                {selectedSection !== "contact" && <TextField select value={newRegister['status'] || '-1'} onChange={onHandleChange.bind(this, "status", "", null )} label={"Estatus (Obligatorio)"} size='small' color='secondary' variant='standard' sx={{mb: 2}} fullWidth InputLabelProps={{ shrink: true }} required>
                                    <MenuItem value={"-1"} disabled>Seleccione</MenuItem>
                                    {platformData && platformData['contactStatus']?.map((item, index) => {
                                        return <MenuItem key={`option-${index}`} value={item.key}>{item.label}</MenuItem>
                                    })}
                                </TextField>}
                            </>
                        }
                    </FlexGrid>
                    {error && <Typography variant="small" color="required">{error}</Typography>}

                </FlexGrid>
            </Box>

            <Box width={600} display={'flex'} position={'fixed'} bottom={0} px={5} pb={5} sx={{backgroundColor: '#f5f8fa'}} justifyContent={'space-between'} alignItems={'center'}>
                <FlexGrid container fullHeight fullWidth justify='space-between' alignItems='flex-end' style={{ marginTop: '20px' }}>
					<FlexGrid item>
						<Button onClick={tabActive === 'create' ? onCreate : () => onUpdate()} disabled={isValid} size='normal'>
							Aceptar
						</Button>
					</FlexGrid>
					<FlexGrid item>
						<Button onClick={onClose} buttonType='secondary' size='normal'>
							Cancelar
						</Button>
					</FlexGrid>
				</FlexGrid>
            </Box>

        </SwipeableDrawer>
    )
};